var _path, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusSign(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    viewBox: "0 0 45 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 354"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 333",
    d: "M0 4C0 1.79086 1.79086 0 4 0H40.4256C42.6348 0 44.4256 1.79086 44.4256 4V28C44.4256 30.2091 42.6348 32 40.4256 32H4C1.79086 32 0 30.2091 0 28V4Z",
    fill: "#2541A4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "add"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_81_485",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 2,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 8,
    y: 2,
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_81_485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "add_2",
    d: "M20.8333 17.1666H13.8333V14.8333H20.8333V7.83331H23.1666V14.8333H30.1666V17.1666H23.1666V24.1666H20.8333V17.1666Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSign);
export default __webpack_public_path__ + "static/media/plusSign.f902abb1644de132c69556c97c11760e.svg";
export { ForwardRef as ReactComponent };